import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FamilyCalendar from './FamilyCalendar';

const FamilySpace = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('calendar');

  return (
    <div className="max-w-[1200px] mx-auto px-5 pt-20 pb-10 min-h-screen max-md:px-4 max-md:pt-[70px] max-md:pb-8">
      <header className="text-center mb-8">
        <h1 className="text-[40px] font-bold text-[var(--color-text-primary)] m-0 mb-3 tracking-[-0.02em] max-md:text-[28px]">{t('family.title')}</h1>
        <p className="text-[var(--color-text-tertiary,#86868b)] text-lg m-0 max-md:text-[15px]">{t('family.subtitle')}</p>
      </header>

      {/* 탭 네비게이션 */}
      <div className="flex justify-center gap-3 mb-8 max-md:flex-col max-md:items-stretch">
        <button
          className={`flex items-center gap-2 py-3 px-6 border-none rounded-[980px] text-[15px] font-medium cursor-pointer transition-all duration-200 max-md:justify-center
            ${activeTab === 'calendar'
              ? 'bg-[#3B82F6] text-white'
              : 'bg-[var(--color-bg-secondary)] text-[var(--color-text-primary)] hover:bg-[var(--color-border-light,#e5e5e7)]'}`}
          onClick={() => setActiveTab('calendar')}
        >
          <span className="text-lg">📅</span>
          {t('family.calendar.title')}
        </button>
        <button
          className={`flex items-center gap-2 py-3 px-6 border-none rounded-[980px] text-[15px] font-medium cursor-pointer transition-all duration-200 max-md:justify-center
            ${activeTab === 'gallery'
              ? 'bg-[#3B82F6] text-white'
              : 'bg-[var(--color-bg-secondary)] text-[var(--color-text-primary)] hover:bg-[var(--color-border-light,#e5e5e7)]'}`}
          onClick={() => setActiveTab('gallery')}
        >
          <span className="text-lg">🖼️</span>
          {t('family.gallery.title')}
        </button>
      </div>

      {/* 탭 컨텐츠 */}
      <div className="bg-transparent">
        {activeTab === 'calendar' && <FamilyCalendar />}

        {activeTab === 'gallery' && (
          <div className="bg-white rounded-[20px] py-20 px-10 text-center shadow-[0_2px_12px_rgba(0,0,0,0.08)] max-md:py-12 max-md:px-6">
            <div className="text-[64px] mb-6 opacity-50 max-md:text-[48px]">🖼️</div>
            <h2 className="text-[28px] font-semibold text-[var(--color-text-primary)] m-0 mb-3 max-md:text-[22px]">{t('family.gallery.title')}</h2>
            <p className="text-base text-[var(--color-text-tertiary,#86868b)] m-0 mb-6 max-w-[400px] mx-auto">{t('family.gallery.description')}</p>
            <span className="inline-block py-2 px-5 bg-gradient-to-br from-[#3B82F6] to-[#8B5CF6] text-white rounded-[980px] text-sm font-semibold">Coming Soon</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FamilySpace;
